import { atom, getDefaultStore, useAtom } from "jotai";
import React from "react";
import { useI18n } from "../utils/lni18n";


export type error = {
  header: string,
  message: string
};

let dialog: HTMLDialogElement | null;

const store = getDefaultStore();
export const errorAtom = atom<error | undefined>(undefined);
errorAtom.debugLabel = "errorAtom";

export const SetError = (error: error) =>{
  store.set(errorAtom, error);
}

const closeDialog = ()=>{
  if( dialog) dialog.close();
}


store.sub(errorAtom, () => {
  if (store.get(errorAtom) !== undefined && dialog) {
    dialog.showModal();
  }
});


const ErrorDialog: React.FC<unknown> = () => {

  const { languageService: t } = useI18n();

  const [errorData] = useAtom(errorAtom);

  const setRef = React.useCallback((el: HTMLDialogElement) => {
    dialog = el;
  }, []);

  return <dialog ref={setRef} className="md">
    <h4>{errorData?.header}</h4>
    <hr />
    <div  className="preserve-white mt-2 mb-3">{errorData?.message}</div>
    <button onClick={closeDialog} className="mt-3 btn btn-default">{t.getText("close")}</button>
  </dialog>
}

export default ErrorDialog
